function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.7472 60.9272C31.5487 72.7641 49.0902 74.4142 60.9272 64.6127C72.7641 54.8112 74.4142 37.2697 64.6127 25.4327C54.8112 13.5958 37.2697 11.9457 25.4327 21.7472C13.5958 31.5487 11.9457 49.0902 21.7472 60.9272Z",
  fill: "white",
  stroke: "url(#paint0_linear)",
  strokeWidth: 5
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.2281 58.8993C36.8834 54.2948 46.8353 50.6434 53.1671 59.5",
  stroke: "url(#paint1_linear)",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.6429 42.339C35.0336 42.339 36.9715 40.401 36.9715 38.0104C36.9715 35.6198 35.0336 33.6818 32.6429 33.6818C30.2523 33.6818 28.3143 35.6198 28.3143 38.0104C28.3143 40.401 30.2523 42.339 32.6429 42.339Z",
  fill: "url(#paint2_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54.0879 42.339C56.4785 42.339 58.4165 40.401 58.4165 38.0104C58.4165 35.6198 56.4785 33.6818 54.0879 33.6818C51.6973 33.6818 49.7593 35.6198 49.7593 38.0104C49.7593 40.401 51.6973 42.339 54.0879 42.339Z",
  fill: "url(#paint3_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 56.7743,
  y1: 15.9666,
  x2: 53.9453,
  y2: 72.4969,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E03BFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6831DE"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 38.7944,
  y1: 59.5,
  x2: 41.0133,
  y2: 52.0102,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E03BFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6831DE"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 30.7311,
  y1: 33.6818,
  x2: 37.2235,
  y2: 39.6291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E03BFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6831DE"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 52.1761,
  y1: 33.6818,
  x2: 58.6684,
  y2: 39.6291,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E03BFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6831DE"
})));

var Svg404Icon = function Svg404Icon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg404Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404Icon.26a0c39b.svg";
export { ForwardRef as ReactComponent };